import css from './users.module.scss';

import { memo, useEffect, useState } from 'react';

import { useUserEditor } from 'com/UserEditor';
import { apiGetUsers } from 'core/api';
import { getAdminUrl } from 'core/paths';
import { FrameHeader, FramePreloader } from 'core/ui/Frame';
import { MenuItem } from 'core/ui/Menu';
import { useMessageModal } from 'core/ui/MessageModal';
import ICONS from 'core/ui/icons';

import UserPanel from './UserPanel';

const Users = () => {
  const [users, setUsers] = useState<TRichUser[]>([]);
  const { showError } = useMessageModal();
  const { createUser } = useUserEditor();
  const isLoading = !users.length;

  const reloadUsers = () => {
    apiGetUsers().then(setUsers).catch(showError);
  };

  useEffect(() => {
    reloadUsers();
  }, []);

  return (
    <>
      <FrameHeader
        closeLink={getAdminUrl()}
        menuItems={
          <MenuItem
            icon={ICONS.Plus}
            label="Add user"
            onClick={() => createUser().then(reloadUsers).catch(showError)}
          />
        }
      >
        Admin Page: Users
      </FrameHeader>
      <div className={css.list}>
        {users.map(user => (
          <UserPanel key={user.uid} user={user} reloadUsers={reloadUsers} />
        ))}
      </div>

      {isLoading && <FramePreloader />}
    </>
  );
};

export default memo(Users);
